/**
 * AdminDataApiService — recycle bin, restore, and purge (admin only).
 */

import { ApiClient } from '../ApiClient.js';

const BASE = '/api/v1/admin/data-management';

export const DATA_ENTITY_TYPES = [
    { key: 'deals', label: 'Deals' },
    { key: 'accounts', label: 'Accounts' },
    { key: 'contacts', label: 'Contacts' },
    { key: 'users', label: 'Users' },
    { key: 'goals', label: 'Goals' },
    { key: 'commissions', label: 'Commissions' },
    { key: 'activities', label: 'Activities' }
];

export const IMPORT_ENTITY_TYPES = [
    { key: 'accounts', label: 'Accounts' },
    { key: 'contacts', label: 'Contacts' },
    { key: 'deals', label: 'Deals' }
];

export class AdminDataApiService {
    static async listDeleted(entityType, { page = 1, per_page = 50, search = null } = {}) {
        const params = { page, per_page };
        if (search) params.search = search;
        const res = await ApiClient.get(`${BASE}/${encodeURIComponent(entityType)}/deleted`, params);
        const list = Array.isArray(res) ? res : (res?.data ?? []);
        const meta = res?.meta ?? { page, per_page, total: list.length };
        return { items: list, meta };
    }

    static async restore(entityType, id) {
        return ApiClient.post(`${BASE}/${encodeURIComponent(entityType)}/${encodeURIComponent(id)}/restore`, {});
    }

    static async restoreBulk(entityType, ids) {
        return ApiClient.post(`${BASE}/${encodeURIComponent(entityType)}/restore-bulk`, { ids });
    }

    static async purge(entityType, id) {
        return ApiClient.delete(`${BASE}/${encodeURIComponent(entityType)}/${encodeURIComponent(id)}`);
    }

    static async purgeBulk(entityType, ids) {
        return ApiClient.post(`${BASE}/${encodeURIComponent(entityType)}/purge-bulk`, { ids });
    }

    static async purgeSoftDeleted(entityType) {
        return ApiClient.post(`${BASE}/${encodeURIComponent(entityType)}/purge-soft-deleted`, {});
    }

    static async purgeAll(confirmation) {
        return ApiClient.post(`${BASE}/purge-all`, { confirmation });
    }

    static previewImport(entityType, file, skipSamples) {
        const body = new FormData();
        body.append('entity_type', entityType);
        body.append('skip_samples', skipSamples ? 'true' : 'false');
        body.append('file', file);
        return ApiClient.request('POST', `${BASE}/imports/preview`, { body, timeout: 120000 });
    }

    static startImport(entityType, file, skipSamples) {
        const body = new FormData();
        body.append('entity_type', entityType);
        body.append('skip_samples', skipSamples ? 'true' : 'false');
        body.append('file', file);
        return ApiClient.request('POST', `${BASE}/imports`, { body, timeout: 30000 });
    }

    static getImportJob(jobId) {
        return ApiClient.get(`${BASE}/imports/${encodeURIComponent(jobId)}`);
    }
}
